import React, {Fragment} from 'react'
import { graphql, StaticQuery, Link } from 'gatsby'
import Banner from '../../assets/senior_banner.svg'
import BlueTick from '../../assets/blue_tick.svg'
import { logEvent, pushToDataLayer } from '../Analytics'


class Header extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
    const {headerBackBlue} = this.props.query;
    const {logo} = this.props;
        return(
            <Fragment>
                <section className="barns-bannet1" style={{background: `url(${headerBackBlue.publicURL})`}}>
                    <div className="custom-container">
                        <div className="content-img">
                            <div className="col-lg-6 col-sm-6 col-md-6 col-xs-12">
                                <div className="row">
                                <div className="form-sec">
                                    <h3 className="desktop">Ge dina äldre barn de bästa <br/> förutsättningarna.</h3>	
                                     <h3 className="for-mobile">Ge dina äldre barn de bästa <br/> förutsättningarna.</h3>    
                                    <ul>
                                        <li> <BlueTick/>Anpassade övningar efter elevens årskurs och läroplan</li>
                                        <li><BlueTick/>Hundratals animerade  mattelektioner</li>
                                        <li><BlueTick/>Utvecklad av erfarna pedagoger, lärare och forskare</li>
                                        <li><BlueTick/>Tillgänglig alla dagar, dygnet runt</li>
                                    </ul>
                                    <div className="btn-sec">
                                        <Link to="/register" className="prova" onClick={e => {logEvent(
                                            `Senior page Prova gratis i 30 dagar button`,
                                            `Senior page Prova gratis i 30 dagar button was clicked`
                                            );
                                            pushToDataLayer(
                                                'userClick',
                                                'Senior Page Prova Gratis I 30 Dagar Button',
                                                'Senior Page Prova Gratis I 30 Dagar Button Was Clicked'
                                            )}
                                        }
                                            >PROVA GRATIS NU <span className="line">Ordinarie pris 99 kr/mån</span></Link>
                                        {/* <p style={{ margin: '1rem 0 0 0', textAlign: 'left', maxWidth: '16rem', color: '#000', fontSize: '0.8rem' }}>* 9 Januari 2020</p> */}
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div className="col-lg-6 col-sm-6 col-md-6 col-xs-12">
                                <div className="row">
                                    <figure>
                                        <Banner/>                            
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    headerBackBlue: file(relativePath: {regex: "/senior_background/"}) {
                        publicURL
                    }                    
                }`
            }
        render={(data)  => (
           <Header query={data} {...props}/>
        )}
    />
)